import { Route, Switch, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import "./App.css";
import { LanguageContextProvider } from "./hooks/language-context";
import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Header from "./layout/header/Header";
import Footer from "./layout/footer/Footer";

import configureTypesStore from "./hooks/types-store";
import configureSensorsStore from "./hooks/sensors-store";
import MapPage from "./pages/MapPage";
import Map from "./components/Map/Map";
import Charts from "./components/charts/Charts";
import AppProviders from "./hooks/AppProviders";
import { activeData, activeTiles } from "./components/Map/utils";
import Home from "./components/Home/Home";
import styled from "styled-components";
import ThreeDimensionsPage from "./components/ThreeDimensions/ThreeDimensionsPage";
import UserProfile from "./components/UserProfile";
import RegistrationForm from "./components/RegistrationForm";

i18next
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "el"],
    fallbackLng: "el",
    debug: false,
    // Options for language detector
    detection: {
      order: ["path", "cookie"],
      caches: ["cookie"],
      cookieMinutes: 7 * 24 * 60 * 60 * 1000, //7 days
    },
    react: { useSuspense: false },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
  })
  .catch((error) => console.warn(error));

configureTypesStore();
configureSensorsStore();

const App = () => {
  const history = useLocation();
  return (
    <AppProviders features={activeData.states}>
      <LanguageContextProvider>
        <AppMain
          $imgUrl={
            window.location.href.includes("profile") ||
            window.location.href.includes("register")
              ? process.env.PUBLIC_URL + "/backgroundCity_blurred.png"
              : process.env.PUBLIC_URL + "/backgroundCity.png"
          }
        >
          {history.pathname !==
            "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" &&
            history.pathname !==
              "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet" && (
              <Header />
            )}
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>

            <Route path="/map" exact>
              <Map />
            </Route>

            <Route path="/3d" exact>
              <ThreeDimensionsPage />
            </Route>

            <Route path="/profile" exact>
              <UserProfile />
            </Route>

            <Route path="/register" exact>
              <RegistrationForm />
            </Route>

            <Route
              path="/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451"
              exact
            >
              <Map mapFrame={true} />
            </Route>

            <Route
              path="/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet"
              component={Charts}
              exact
            />
          </Switch>
          {/* 
          <MainContainer
            $isSpecial={
              history.pathname ===
                "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" ||
              history.pathname ===
                "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet"
            }
          >
            
          </MainContainer>
           */}
          {history.pathname !==
            "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" &&
            history.pathname !==
              "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet" && (
              <Footer />
            )}
        </AppMain>
      </LanguageContextProvider>
    </AppProviders>
  );
};

export default App;

// margintop: ${(props) => (props.$isSpecial ? "0" : "unset")};
// marginbottom: ${(props) => (props.$isSpecial ? "0" : "unset")};
const MainContainer = styled.main`
  height: ${(props) => (props.$isSpecial ? "100%" : "calc(100vh - 100px)")};
  width: 100%;
`;

const AppMain = styled.div`
  width: 100vw;
  height: 100vh;

  background-image: url(${(props) => props.$imgUrl});
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* background-position: 50%; */
  background-size: cover;
`;
